import { render, staticRenderFns } from "./myPhotoView.vue?vue&type=template&id=6e28e51b&"
import script from "./myPhotoView.vue?vue&type=script&lang=js&"
export * from "./myPhotoView.vue?vue&type=script&lang=js&"
import style0 from "./myPhotoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports